<div class="row form" *ngIf="book != null">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12 p-l-0 p-r-0">
    <div class="page-title-box form__head">
      <div class="row align-items-center">
        <div class="col-sm-4">
          <h4 class="page-title form__head__title" (click)="cancel()">
            <i class="fas fa-arrow-left m-r-5"></i>Detalle Cuadre</h4>
        </div>
        <div class="col-sm-8 form__head__boxBtn">
          <button class="btn btn-sm btn-danger" *ngIf="book.is_debt == false" (click)="delete(book)"><i
              class="fas fa-trash-alt m-r-2"></i>Borrar</button>
          <button type="button" class="btn btn-success m-r-5" *ngIf="book.is_debt == false" (click)="isDebt()">
            <i class="fas fa-check m-r-5"></i> LIQUIDAR
          </button>
          <button type="button" class="btn btn-light btn-sm" (click)="printer()">
            <i class="fas fa-print m-r-5"></i> Imprimir
          </button>
        </div>
      </div> <!-- end row -->
    </div>
  </div>
  <div class="col-lg-12 p-l-0 p-r-0" id="body">
    <div class="card m-b-20">
      <div class="card-body p-l-5 p-r-5 p-t-5 p-b-0 faq-box boder-left-dark">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__background">
            <div id="test" class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail position-relative">
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                <div class="child-left">Código</div>
                <div class="child-right">
                  <span class="bold color-link">{{book.code}}</span>
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                <div class="child-left">Fecha generada</div>
                <div class="child-right">
                  {{book.created_at | date: 'mediumDate'}}
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                <div class="child-left">Hotel</div>
                <div class="child-right bold">
                  {{book.tradename}}
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                <div class="child-left">Observaciones</div>
                <div class="child-right">
                  <span>{{book.observation}}</span>
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                <div class="child-left">Estado</div>
                <div class="child-right">
                  <span *ngIf="!book.is_debt" class="badge badge-warning">No liquidado</span>
                  <span *ngIf="book.is_debt" class="badge badge-success">Liquidado</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="table-responsive">
        <table class="table mb-0 table-sm">
          <thead class="thead-default">
            <tr>
              <th class="white-space-nowrap">
                DATOS RESERVA
              </th>
              <th class="w-20 f-s-10">
                Habitación
              </th>
              <th class="f-s-10 w-5">#PAX</th>
              <th class="f-s-10 w-5">#HAB</th>
              <th class="f-s-10 w-10">Chck-in</th>
              <th class="f-s-10 w-10">Chck-out</th>
              <th class="f-s-10 w-10">#Noches </th>
              <th class="f-s-10 w-10">Precio</th>
              <th class="f-s-10 w-10">-S/Dscto</th>
              <th class="f-s-10 w-10">S/Adicio</th>
              <th class="f-s-10 w-10">Obs.</th>
              <th class="f-s-10">Subtotal</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngIf="bookings.length == 0">
              <tr>
                <td colspan="7">
                  <i class="m-r-5"></i>Debe seleccionar el
                  hotel para cargar las reservas
                </td>
              </tr>
            </ng-container>
            <ng-container *ngIf="bookings.length > 0">
              <tr *ngFor="let item of bookings; let i = index">
                <td>
                  <p class="white-space-nowrap bold text-primary f-s-10 m-b-0">
                    COD:
                    {{item.code}}</p>
                  <p class="f-s-9 m-b-0">{{item.client_fullname}}, DOC:
                    {{item.client_document}}</p>
                </td>
                <td style="padding: 0 !important;" colspan="11">
                  <ng-container *ngIf="item.detailbedrooms_data.length == 0">
              <tr>
                <td colspan="7">
                  <i class="m-r-5"></i>No se encontaron
                  reservas de habitaciones pendientes
                </td>

              </tr>
            </ng-container>
            <ng-container *ngIf="item.detailbedrooms_data.length > 0">
              <ng-container *ngFor="let data of item.detailbedrooms_data; let index_ = index">
                <tr>
                  <td class="w-20">
                    {{data.typebedroom}}
                  </td>
                  <td class="text-center w-5">
                    {{data.guests}}
                  </td>
                  <td class="text-center w-5">
                    {{data.quantity}}
                  </td>
                  <td class="w-10">
                    {{data.date_checkin}}
                  </td>
                  <td class="w-10">
                    {{data.date_checkout}}
                  </td>
                  <td class="w-10 text-center">
                    {{data.nights}}
                  </td>
                  <td class="w-10">
                    {{data.price}}
                  </td>
                  <td class="w-10">
                    - {{data.discount}}
                  </td>
                  <td class="w-10">
                    + {{data.additional}}
                  </td>
                  <td class="w-10">
                    {{data.observation}}
                  </td>
                  <td class="text-center nowrap">
                    <span class="f-s-11">{{ data.subtotal | currency:'S/'}}</span>
                    <i *ngIf="data.is_selected" class="fas fa-check m-l-4"></i>
                  </td>
                </tr>
              </ng-container>
            </ng-container>
            </td>
            </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
      <div *ngIf="bookings.length > 0" class="col-lg-12 m-t-15">
        <div class="row justify-content-md-end">
          <div class="form-group col-lg-3">
            <div class="input-group">
              <div class="input-group-prepend">
                <div class="input-group-text bold f-s-12">T.CUADRE S/. <span class="required-table"></span></div>
              </div>
              <input type="text" class="form-control form-control-sm text-right bold" id="total_block" disabled
                value="{{book.total_block}}">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
